import { z } from 'zod';

/**
 * DSA-Meldung (Notice & Action, Art. 16 DSA (EU) 2022/2065).
 * Felder + Constraints 1:1 aus dem Prototyp legal/dsa-report.html.
 * `content_type` ist im Prototyp ein leerer Select-Stub (keine Optionen) →
 * bewusst weggelassen. `good_faith` MUSS bestätigt sein (z.literal(true)).
 */
export const DsaReportSchema = z.object({
  name: z.string().min(1, 'Pflichtfeld').max(200),
  email: z.string().email('Ungültige E-Mail-Adresse'),
  contentLocation: z.string().min(1, 'Pflichtfeld').max(2000),
  reason: z
    .string()
    .min(20, 'Bitte begründe deine Meldung mit mindestens 20 Zeichen.')
    .max(5000),
  goodFaith: z.literal(true, {
    errorMap: () => ({
      message: 'Bitte bestätige die Treu-und-Glauben-Erklärung.',
    }),
  }),
});

export type DsaReportInput = z.infer<typeof DsaReportSchema>;
